import { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { EyeFill, Pencil, Plus, Trash } from "react-bootstrap-icons";
import { toast } from "react-toastify";
import Grid, { GridColumn, GridHeader, GridRow } from "../../components/Grid/Grid";
import WebService from "../../utility/WebService";
import HelperService from "../../utility/HelperService";
import PageTitle from "../../components/PageTitle/PageTitle";
import { permissionsInterface } from "../onBoarding/onBoardingTypes";
import { useSelector } from "react-redux";
import { PiExport } from "react-icons/pi";
import CustomerDetail from "./CustomerDetail";

const headers: GridHeader[] = [
    {
        title: "Name",
        class: "text-left",
        isSorting: true,
        isAsc: true,
        sortingKey: "customer_name",
    },
    {
        title: "Phone Number",
        class: "text-left",
        isSorting: true,
        isAsc: true,
        sortingKey: "customer_phone",
    },
    {
        title: "Action",
        class: "text-center freeze-column",
        headerClass: "text-center",
        isSorting: false,
        isFilter: false,
        isFreeze: true,
    }
];

const Customers = () => {
    const navigate = useNavigate();
    const nextOffset = useRef<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [rows, setRows] = useState<GridRow[]>([]);
    const token = useSelector((state: any) => state.OnBoardingReducer);
    const [permissions, setPermissions] = useState<permissionsInterface | null>(null);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [showCustomer, setShowCustomer] = useState<boolean>(false);
    const [selectedCustomer, setSelectedCustomer] = useState<any>({});

    useEffect(() => {
        if (token && token.token && token.permissions && !!token.permissions.length) {
            setPermissions(token.permissions.find((item: any) => item.name === "CUSTOMERS"));
        }
    }, [token]);

    const getUsersList = (offset: number, keyword?: string, startDate?: Date, endDate?: Date, order_by?: string, sort_by?: string) => {
        nextOffset.current = offset;
        if (nextOffset.current < 0 || isLoading) return;
        nextOffset.current == 0 && setIsLoading(true);
        WebService.getAPI({
            action: `customer/list?limit=10&offset=${offset}&keyword=${keyword ? keyword : ""
                }&sort_by=${order_by ?? "asc"}&order_by=${sort_by ?? "created_at"}&from_date=${startDate ? startDate : ""}&to_date=${endDate ? endDate : ""
                }`,
            body: null,
        }).then((res: any) => {
            setIsLoading(false);
            let rows: GridRow[] = [];
            for (var i in res.customers) {
                let columns: GridColumn[] = [];
                columns.push({ value: res.customers[i].customer_name });
                columns.push({ value: res.customers[i].customer_phone ? HelperService.getFormattedContact(res.customers[i].customer_phone) : "N/A" });
                columns.push({ value: actionList(res.customers[i]) });
                rows.push({ data: columns });
            }
            setRows(rows);
            setTotalCount(res.count);
        }).catch((e) => { setIsLoading(false); });
    };

    const onSortList = (offset: number, isAscending?: boolean, key?: string) => {
        getUsersList(
            offset,
            null as any,
            null as any,
            null as any,
            isAscending ? "asc" : "desc",
            key
        );
    };

    const exportCustomers = () => {
        WebService.getAPI({
            action: `customer/export`,
            body: null,
            responseType: 'arraybuffer',
        }).then((response: any) => {
            const url = window.URL.createObjectURL(new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `customers_${new Date().toISOString()}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }).catch((e) => {
            toast.error("Failed to export customers");
        });
    };

    const actionList = (data: any) => {
        return (
            <div className="action-btns">
                <button className="cursor-pointer  btn-edit btn" onClick={() => { setShowCustomer(true); setSelectedCustomer(data); }} > {" "} <EyeFill />{" "} </button>
            </div>
        );
    };


    return (
        <>
            <CustomerDetail isShow={showCustomer} isClose={(e: boolean) => { setShowCustomer(e); setSelectedCustomer({}); }} data={selectedCustomer} />
            {permissions && permissions.can_read && <div className="app-page page-dashboard">
                <div className="d-flex justify-content-between align-items-center ">
                    <PageTitle title="Customers" backArrow={false} />
                    {permissions && permissions.can_write && permissions.can_update && <Button
                        className="btn btn-brand-1 mb-3 ms-2"
                        onClick={() => { exportCustomers(); }}
                    >
                        <PiExport size={20} className="ms-1" /> Export
                    </Button>}
                </div>
                <div className="table-card">
                    <Grid
                        rows={rows}
                        showSearch={true}
                        headers={headers}
                        showDateFilter={false}
                        onPageChange={getUsersList}
                        errorMessage={"No Customer Found"}
                        ShowLoader={isLoading}
                        onSort={onSortList}
                        count={totalCount}
                    />
                </div>
            </div>}
        </>
    );
};

export default Customers;
